import { motion } from "framer-motion";
import { IMAGES } from "../constants/site";

const services = [
  {
    name: "Lash Extensions",
    description:
      "Individually applied extensions, mapped to your eye shape. From a soft natural set to a full, dramatic look — always weightless, always yours.",
    image: IMAGES.extensions,
    alt: "Close-up of lash extensions by Haus of Lash",
    position: "center 30%",
    testid: "service-extensions",
  },
  {
    name: "Lash Lifts",
    description:
      "Your natural lashes, lifted and curled from the root. Low-maintenance, wide-awake eyes that last for weeks — no extensions needed.",
    image: IMAGES.lifts,
    alt: "Lash applicator brushes at Haus of Lash",
    position: "center",
    fit: "contain",
    testid: "service-lifts",
  },
];

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-10 flex flex-col gap-6 lg:mb-14 lg:flex-row lg:items-end lg:justify-between"
        >
          <h2 className="font-serif-display text-5xl font-light tracking-tight text-[#E6D5C3] lg:text-6xl">
            The Services
          </h2>
          <p className="max-w-sm text-sm font-light leading-relaxed text-[#A89B8F]">
            Two treatments, one standard: detail. Pricing will be finalized soon —
            announced first on Instagram.
          </p>
        </motion.div>

        <div className="border-t border-[#332A24]">
          {services.map((service, i) => (
            <motion.article
              key={service.name}
              data-testid={service.testid}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className={`grid grid-cols-1 items-center gap-10 border-b border-[#332A24] py-16 lg:grid-cols-12 lg:gap-16 lg:py-20 ${
                i % 2 === 1 ? "" : ""
              }`}
            >
              <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="group overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.alt}
                    data-testid={`${service.testid}-image`}
                    style={{ objectPosition: service.position }}
                    className={`h-72 w-full ${service.fit === "contain" ? "object-contain" : "object-cover"} transition-transform duration-700 ease-out group-hover:scale-105 lg:h-96`}
                  />
                </div>
              </div>
              <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <span className="text-xs uppercase tracking-[0.35em] text-[#C8A88B]">
                  0{i + 1}
                </span>
                <h3 className="mt-4 font-serif-display text-4xl font-light tracking-tight text-[#E6D5C3] lg:text-5xl">
                  {service.name}
                </h3>
                <p className="mt-6 max-w-lg text-base font-light leading-relaxed text-[#A89B8F]">
                  {service.description}
                </p>
                <a
                  data-testid={`${service.testid}-enquire-link`}
                  href="#enquire"
                  className="mt-8 inline-block text-xs uppercase tracking-[0.2em] text-[#E6D5C3] underline underline-offset-8 transition-colors duration-200 hover:text-[#DEBFA2]"
                >
                  Inquire about this
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
